import React from 'react'
import { useTranslation } from 'next-i18next'
import useOrder from 'modules/order/state/order/use-order'
import FlowTwoColumnStepLayout from 'modules/flow/components/two-column-step-layout/two-column-step-layout'
import useReloadPage from 'utils/hooks/useReloadPage'
import ThankYouStepContent from './thank-you-step-content'

const ThankYouStep = ({}) => {
  const { t } = useTranslation()
  const order = useOrder()
  const { reload, reloading } = useReloadPage()

  return (
    <>
      <FlowTwoColumnStepLayout.Header
        hideBackButton
        title={t('thankYouStep.header.title', {
          defaultValue: 'Thank you, {{firstName}}, for your donation!',
          firstName: order.contact.value.firstName,
        })}
        titleSize="lg"
        titleAlign="left"
      />
      <FlowTwoColumnStepLayout.Body>
        <>
          <ThankYouStepContent />
        </>
      </FlowTwoColumnStepLayout.Body>
      <FlowTwoColumnStepLayout.Footer>
        <FlowTwoColumnStepLayout.FooterButton
          onClick={reload}
          disabled={reloading}
          dataId="make-another-donation-button"
        >
          {t('thankYouStep.footer.makeAnotherDonationButton', 'Make another donation')}
        </FlowTwoColumnStepLayout.FooterButton>
      </FlowTwoColumnStepLayout.Footer>
    </>
  )
}

export default ThankYouStep
